module.exports = __webpack_public_path__ + "static/media/cloudy.svg.cc907c35.png";